var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScholarshipBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 33,
    viewBox: "0 0 44 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 20.1887C21.7589 20.1887 21.5181 20.1427 21.2905 20.0501L1.20176 11.8972C0.475886 11.6025 0 10.8885 0 10.0948C0 9.30105 0.475886 8.58709 1.20176 8.29242L21.2905 0.138942C21.7457 -0.0456629 22.2537 -0.0456629 22.709 0.138942L42.7977 8.29184C43.5235 8.5865 44 9.30047 44 10.0942C44 10.8879 43.5241 11.6019 42.7977 11.8966L22.709 20.0495C22.4813 20.1421 22.2405 20.1881 21.9997 20.1881V20.1887ZM7.06204 10.0942L22.0003 16.1565L36.9385 10.0942L22.0003 4.03195L7.06204 10.0942Z",
    fill: "#105099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0885 21.0938C41.0329 21.0938 40.1775 20.225 40.1775 19.1529V10.201C40.1775 9.12888 41.0329 8.26001 42.0885 8.26001C43.144 8.26001 43.9995 9.12888 43.9995 10.201V19.1529C43.9995 20.225 43.144 21.0938 42.0885 21.0938Z",
    fill: "#105099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 33C14.9372 33 9.91226 28.0588 9.70184 27.8486C9.33661 27.4834 9.13135 26.9849 9.13135 26.4649V14.3893C9.13135 13.3172 9.9868 12.4483 11.0423 12.4483C12.0979 12.4483 12.9533 13.3172 12.9533 14.3893V25.5815C14.2698 26.6652 17.7214 29.1175 21.9998 29.1175C26.2782 29.1175 29.7407 26.6705 31.0462 25.5867V14.3887C31.0462 13.3166 31.9017 12.4478 32.9572 12.4478C34.0128 12.4478 34.8682 13.3166 34.8682 14.3887V26.4643C34.8682 26.9844 34.6629 27.4829 34.2977 27.848C34.0873 28.0582 29.0624 32.9994 21.9998 32.9994V33Z",
    fill: "#105099"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarshipBlue);
export default __webpack_public_path__ + "static/media/scholarship-blue.b32c195a2511252df10afa05639b9452.svg";
export { ForwardRef as ReactComponent };